import { useTranslation } from 'react-i18next'

import { TableHeaderConfig } from 'js/components/Table/Table.types'

const useTableHeaders = (): TableHeaderConfig[] => {
    const { t } = useTranslation()

    return [
        {
            name: 'title',
            label: t('form.title'),
            style: { minWidth: 200 },
        },
        {
            name: 'ownerName',
            label: t('global.owner'),
            style: { minWidth: 80 },
        },
        {
            options: [
                {
                    name: 'timeUpdated',
                    label: t('global.last-edited'),
                    defaultOrderDirection: 'desc' as const,
                },
                {
                    name: 'timePublished',
                    label: t('global.published'),
                    defaultOrderDirection: 'desc' as const,
                },
            ],
            align: 'right' as const,
            style: { minWidth: 100 },
        },
        {
            name: 'actions',
            style: { width: 40 },
        },
    ]
}

export default useTableHeaders
